<template>
  <unex-dialog
    width="400px"
    position="center"
    :title="$t('frame.Set_newpassword')"
    :visible.sync="visible"
    :append-to-body="true"
    :hasSubmit="false"
    :close-on-click-modal="false"
    custom-class="password-dialog"
    :before-close="cancle"
  >
    <div class="set-newpassword">
      <div class="timeout-title">
        <unex-icon svg="warn" class="warn"></unex-icon
        ><span>{{ this.$t("frame.expired") }}</span>
      </div>
      <div v-if="visible">
        <el-form
          :model="passwordInfo"
          :rules="passwordRule"
          ref="passwordInfo"
          label-width=""
          label-position="top"
          class="ruleForm"
          onsubmit="return false;"
        >
          <el-form-item style="display:none" :label="$t('frame.new_password')">
            <el-input
              id="resetPassword"
              type="text"
              auto-complete="new-password"
              @keyup.native="setType"
            >
            </el-input>
          </el-form-item>
          <el-form-item
            :label="$t('frame.new_password')"
            prop="newpassword"
            :error="errors.passwordErrorInfo"
          >
            <el-input
              size="small"
              type="text"
              v-model="passwordInfo.newpassword"
              @focus="passRuleVisible = true"
              @blur="passRuleVisible = false"
              auto-complete="new-password"
              @keyup.native="setType"
            ></el-input>
          </el-form-item>
          <el-form-item class="rule-list" v-show="passRuleVisible">
            <span>{{ this.$t("frame.passwordRule") }}</span>
            <li v-for="(label, index) in checkedPasswordLabel" :key="index">
              {{ label }}
            </li>
          </el-form-item>
          <el-form-item
            :label="$t('frame.confirm_password')"
            prop="confirmPassword"
            :error="errors.confirmErrorInfo"
          >
            <el-input
              size="small"
              type="text"
              auto-complete="new-password"
              @keyup.native="setType"
              v-model="passwordInfo.confirmPassword"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="footer">
        <el-button size="small" @click="cancle">{{
          this.$t("frame.cancel")
        }}</el-button>
        <el-button
          size="small"
          type="primary"
          @click="setNewPassword('passwordInfo')"
          >{{ this.$t("frame.submit") }}</el-button
        >
      </div>
    </div>
  </unex-dialog>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  props: {
    showDialog: null
  },
  watch: {
    showDialog(val) {
      this.visible = val;
      if (val) {
        this.getPassword();
      } else {
        this.passwordInfo.newpassword = null;
        this.passwordInfo.confirmPassword = null;
      }
    }
  },
  data() {
    let confirmPassword = (rule, value, callback) => {
      if (value !== this.passwordInfo.newpassword) {
        callback(new Error(this.$t("frame.passwords_differ")));
      } else {
        callback();
      }
    };

    let validatePass = (rule, value, callback) => {
      let vlen = [],
        element = [];
      //密码规则
      this.ruleList.forEach(item => {
        if (item.indexOf("length") == 0) {
          let vl = item.split("_");
          vlen = vlen.concat(vl[1], vl[2]);
        } else if (item.indexOf("element") == 0) {
          let el = item.split("_");
          element = [el[1]];
        }
      });

      if (vlen[0] <= value.length && value.length <= vlen[1]) {
        let type = element[0];
        let pattern;
        if (type === "high") {
          pattern = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?['\\' \][!$%^*()_+:"<>{}|?#@*&./~\-,= |`;]).*$/;
          if (!pattern.test(value)) {
            callback(new Error(this.$t("frame.special_password")));
          } else {
            callback();
          }
        }
        if (type === "default") {
          pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,20}$/;
          if (!pattern.test(value)) {
            callback(new Error(this.$t("frame.lowerupper_num_password")));
          } else {
            callback();
          }
        }

        if (type === "base") {
          pattern = /(?=.*[\d])?(?=.*[a-zA-Z])(?=.*[\d])/;
          if (!pattern.test(value)) {
            callback(new Error(this.$t("frame.lowercase_num_password")));
          } else {
            callback();
          }
        }
      } else {
        callback(
          new Error(
            this.$t("frame.enter_password") +
              vlen[0] +
              "-" +
              vlen[1] +
              this.$t("frame.bit_password")
          )
        );
      }
    };
    return {
      visible: false,
      passwordInfo: {
        newpassword: null,
        confirmPassword: null
      },
      passwordRule: {
        newpassword: [
          {
            required: true,
            message: this.$t("frame.newpassword_empty"),
            trigger: "blur"
          },
          { validator: validatePass, trigger: "blur" }
        ],
        confirmPassword: [
          {
            required: true,
            message: this.$t("frame.conpassword_empty"),
            trigger: "blur"
          },
          { validator: confirmPassword, trigger: "blur" }
        ]
      },
      errors: {
        passwordErrorInfo: null,
        confirmErrorInfo: null
      },
      passRuleVisible: false
    };
  },
  computed: {
    ...mapState({
      ruleList: state => state.frame.login.passwordRuleList,
      checkedPasswordLabel: state => state.frame.login.checkedPasswordLabel
    })
  },
  created() {},
  methods: {
    ...mapMutations({
      setAllPasswordRole: "frame/login/setAllPasswordRole"
    }),
    ...mapActions({
      getPasswordList: "frame/login/getPasswordList"
    }),
    setType(event) {
      if (event.target.value.length > 0) {
        event.target.type = "password";
      }
    },
    //设置新密码
    setNewPassword(formName) {
      this.errors.passwordErrorInfo = "";
      this.errors.confirmErrorInfo = "";
      this.$refs[formName].validate(async valid => {
        if (valid) {
          let res = await this.$store.dispatch(
            "frame/modifyPassword",
            this.$qs.stringify({
              modifyPassword: this.passwordInfo.newpassword
            })
          );
          if (!res.success) {
            this.errors.passwordErrorInfo = res.message;
          } else {
            this.$message({
              message: this.$t("frame.password_edit_success"),
              type: "success",
              center: true,
              duration: 2000
            });

            this.cancle();
          }
        }
      });
    },
    cancle() {
      this.$emit("setDialog", false);
    },
    getPassword() {
      if (this.$refs["passwordInfo"] !== undefined) {
        this.$refs["passwordInfo"].resetFields();
      }
      this.getPasswordList(this);
    }
  }
};
</script>
